import React from "react";
import AdsManagement from "./AdsManagement";

export default function DeletedAdsManagement() {
  return <AdsManagement />;
}
